import { AppRoutes } from "@/constants/routes";
import { AppColors } from "@/styles/colors";
import { Box, Link, Table, Text } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { v4 } from "uuid";
import { AccountPerson } from "../schema/account.schema";
import { NoDataSmall } from "@/components/common/section-components/NoDataSmall";

interface Props {
  accountPersonData?: AccountPerson[];
}

export const AccountPersonData = ({ accountPersonData }: Props) => {
  const navigate = useNavigate();
  const handleGoToPersonList = (dni: string) => {
    navigate(AppRoutes.PERSONS + `?dni=${dni}`, {
      state: {
        from: AppRoutes.ACCOUNTS_DETAIL,
      },
    });
  };

  if (!accountPersonData?.length) return <NoDataSmall />;
  return (
    <Box marginTop="12px" borderRadius="12px">
      <Table.ScrollArea
        borderRadius="12px"
        css={{
          "@media (max-width: 1350px) and (min-width: 1272px)": {
            maxWidth: "950px",
            height: "122px",
          },
          "@media (max-width: 1414px) and (min-width: 1351px)": {
            maxWidth: "1100px",
            height: "185px",
          },
          "@media (max-width: 1590px) and (min-width: 1415px)": {
            maxWidth: "1250px",
            height: "200px",
          },
          "@media (max-width: 1696px) and (min-width: 1591px)": {
            maxWidth: "1350px",
            height: "233px",
          },
          "@media (max-width: 1900px)": {
            maxWidth: "1500px",
            height: "324.5px",
          },
          "@media (min-width: 1901px)": {
            height: "324.5px",
          },
          // Estilos del scrollbar (solo Webkit)
          "&::-webkit-scrollbar": {
            width: "12px",
            borderRadius: "12px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: AppColors.SCROLL_BG,
            borderRadius: "9px",
          },
          "&::-webkit-scrollbar-track": {
            backgroundColor: "#f0f0f0",
            borderRadius: "12px",
          },
        }}
      >
        <Table.Root
          size="sm"
          striped
          stickyHeader
          interactive
          border={`1px solid ${AppColors.WHITE_BORDER_1}`}
        >
          <Table.Header>
            <Table.Row>
              <Table.ColumnHeader>
                <Text
                  padding="16px"
                  color={AppColors.GRAY_TEXT}
                  fontWeight={700}
                  textTransform="uppercase"
                  fontSize="12px"
                >
                  Nombre y Apellido
                </Text>
              </Table.ColumnHeader>

              <Table.ColumnHeader>
                <Text
                  padding="16px"
                  color={AppColors.GRAY_TEXT}
                  fontWeight={700}
                  textTransform="uppercase"
                  fontSize="12px"
                >
                  DNI
                </Text>
              </Table.ColumnHeader>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {accountPersonData?.map((person) => (
              <Table.Row key={v4()}>
                <Table.Cell>
                  <Text
                    padding="16px"
                    fontWeight={400}
                    fontSize="12px"
                    color={AppColors.BLACK_TEXT_SECONDARY}
                  >
                    {person?.nombre && person.apellido
                      ? `${person?.nombre} ${person?.apellido}`
                      : "-"}
                  </Text>
                </Table.Cell>
                <Table.Cell>
                  <Text
                    padding="16px"
                    fontWeight={400}
                    fontSize="12px"
                    color={AppColors.BLACK_TEXT_SECONDARY}
                  >
                    <Link
                      cursor="pointer"
                      onClick={() => handleGoToPersonList("37628380")}
                    >
                      {person?.documento ?? "-"}
                    </Link>
                  </Text>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table.Root>
      </Table.ScrollArea>
    </Box>
  );
};
